<template>
  <div>
    <div>
      <div
        style="
          padding: 20px;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
        "
      >
        <!-- v-if="selectedClass.classID === 'admin'" -->
        <!-- верхняя кнопка (если нужно перейти на доску почёта) -->
        <div style="width: 100%; display: flex; justify-content: center">
          <v-btn color="primary" to="/honorBoard" style="text-align: center">
            Доска почёта
          </v-btn>
        </div>

        <details style="text-align: auto; width: 700px">
          <summary>Инструкция</summary>
          <div>
            Для создания карточки достижения необходимо заполнить все поля.
            <br />
            <b>Достижение на группу учеников:</b>
            Добавляйте учеников (можно с разных классов) с помощью кнопки
            "Добавить ученика"
            <br />
            <br />
            За каждое достижение начисляются <b>баллы</b>, которые идут в общий
            рейтинг ученика. Вы можете выбрать рекомендованные баллы из списка
            или указать своё количество.
            <br />
            <br />
            <b>Категории достижений:</b>
            <br />
            <b>"Конкурсы и мероприятия":</b> олимпиады, конкурсы, фестивали,
            соревнования (школьные, районные, городские и т.д.)
            <br />
            <b>"Помощь школе":</b> уборка кабинетов, помощь в организации
            мероприятий, дежурство, работа в школьных проектах
            <br />
            <b>"Хорошая дисциплина":</b> отсутствие нарушений за период,
            образцовое поведение
            <br />
            <b>"Учебные успехи":</b> отличная учёба, победы в предметных
            олимпиадах, научные проекты
            <br />
            <b>"Спортивные достижения":</b> победы в соревнованиях, спортивные
            разряды, участие в турнирах
            <br />
            <b>"Творческие успехи":</b> музыка, рисование, театр, танцы,
            литература
            <br />
            <b>"Общественная деятельность":</b> волонтёрство, работа в
            самоуправлении, помощь младшим
            <br />
            <b>"Прочее":</b> другие достижения, не попавшие в категории
            <br />
            <br />
            <b>Рекомендованные баллы:</b>
            <br />
            🟢 1–3 балла — небольшие заслуги (помощь по мелочи, участие)
            <br />
            🔵 5–10 баллов — заметные достижения (победы на школьном уровне,
            активная помощь)
            <br />
            🟡 15–30 баллов — серьёзные достижения (районные, городские
            конкурсы)
            <br />
            🔴 50+ баллов — выдающиеся достижения (республиканские,
            всероссийские, международные)
          </div>
        </details>

        <!-- создание -->
        <div style="width: 100%"></div>
        <div
          style="
            width: 700px;
            padding: 20px;
            margin: 5px;
            border-radius: 5px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            -webkit-box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
            -moz-box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
            box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
          "
        >
          <div style="margin: 10px">
            Создание нового достижения:
            <div>
              <b>Дата:</b>
              <input
                type="date"
                id="Date"
                class="form-control"
                required
                v-model="newAchievements.date"
              />
            </div>
            <div>
              <b>Ответственный за информацию</b>
              <input
                type="text"
                id="responsible"
                class="form-control"
                required
                v-model="newAchievements.responsible"
              />
            </div>
            <div
              v-for="(el, indexcl) in newAchievements.classID"
              :key="indexcl"
              style="display: flex"
            >
              <div style="width: 100px; margin: 3px">
                <b>Класс</b>
                <select
                  class="form-select"
                  id="class"
                  v-model="newAchievements.classID[indexcl]"
                  @change="getStudentsList(indexcl)"
                >
                  <option
                    v-for="(user, index) in classList"
                    :key="index"
                    v-bind:value="user"
                  >
                    {{ user.className }}
                  </option>
                </select>
              </div>

              <div style="width: 200px; margin: 3px">
                <b>Ученик</b>
                <select
                  class="form-select"
                  v-model="newAchievements.studentID[indexcl]"
                >
                  <option
                    v-for="user in studentsList[indexcl]"
                    :key="user._id"
                    v-bind:value="user"
                  >
                    {{ user.FirstName }} {{ user.LastName }}
                  </option>
                </select>
              </div>
            </div>
            <v-card-actions id="addStudent">
              <button @click="addStudentNewAchiev()" class="btn btn-primary">
                Добавить ученика
              </button>
            </v-card-actions>
          </div>

          <div style="margin: 10px">
            <div>
              <b>Категория достижения:</b>
              <select
                class="form-select"
                id="group"
                v-model="newAchievements.group"
                @change="onCategoryChange()"
              >
                <option>Конкурсы и мероприятия</option>
                <option>Помощь школе</option>
                <option>Хорошая дисциплина</option>
                <option>Учебные успехи</option>
                <option>Спортивные достижения</option>
                <option>Творческие успехи</option>
                <option>Общественная деятельность</option>
                <option>Прочее</option>
              </select>
            </div>

            <div>
              <b>Уровень (для конкурсов):</b>
              <select
                class="form-select"
                id="level"
                v-model="newAchievements.level"
                @change="onCategoryChange()"
              >
                <option>Школьный</option>
                <option>Районный</option>
                <option>Городской</option>
                <option>Краевой</option>
                <option>Всероссийский</option>
                <option>Международный</option>
              </select>
            </div>

            <div style="top: 10px">
              <b>Описание достижения:</b>
              <textarea
                name=""
                v-model="newAchievements.description"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="4"
              ></textarea>
            </div>

            <!-- Блок баллов -->
            <div
              style="
                margin-top: 10px;
                padding: 10px;
                background-color: #e8f0fe;
                border-radius: 5px;
              "
            >
              <div>
                <b>Рекомендованные баллы:</b>
                <span style="color: #1976d2; font-weight: bold">
                  {{ recommendedPoints }}
                </span>
                <span
                  v-if="newAchievements.isCustomPoints"
                  style="color: #d32f2f"
                >
                  &nbsp;(вы изменили значение)
                </span>
              </div>

              <div style="display: flex; align-items: center; margin-top: 5px">
                <b style="margin-right: 10px">Баллы за достижение:</b>
                <button
                  class="btn btn-outline-secondary"
                  @click="decPoints()"
                  style="width: 40px"
                >
                  −
                </button>
                <input
                  type="number"
                  class="form-control"
                  style="width: 100px; margin: 0 5px; text-align: center"
                  v-model.number="newAchievements.points"
                  @input="checkCustom()"
                />
                <button
                  class="btn btn-outline-secondary"
                  @click="incPoints()"
                  style="width: 40px"
                >
                  +
                </button>
                <button
                  v-if="newAchievements.isCustomPoints"
                  class="btn btn-link"
                  style="margin-left: 10px"
                  @click="resetPoints()"
                >
                  Сбросить
                </button>
              </div>

              <div style="margin-top: 5px">
                <small>
                  <b>Быстрый выбор:</b>
                  <button
                    v-for="p in [1, 3, 5, 10, 15, 25, 50]"
                    :key="p"
                    class="btn btn-sm btn-outline-primary"
                    style="margin: 2px"
                    @click="setPoints(p)"
                  >
                    {{ p }}
                  </button>
                </small>
              </div>
            </div>

            <v-card-actions id="createNew" style="margin-top: 10px">
              <button
                @click="createAchievements()"
                class="btn btn-success"
                style="width: 250px"
              >
                Создать
              </button>
            </v-card-actions>
          </div>
        </div>

        <div style="width: 100%"></div>

        <!-- Статистика по всем классам (только админ) -->
        <details
          v-if="selectedClass.classID === 'admin'"
          style="text-align: auto; width: auto"
          open
        >
          <summary>Количество баллов по всем классам</summary>
          <div style="margin: 5px; width: 90%">
            <div style="display: flex; justify-content: center; padding: 10px">
              <button
                @click="countAchievementsForAllClasses()"
                class="btn btn-primary"
                style="margin: 10px"
              >
                Загрузить все классы
              </button>
            </div>

            <div
              v-if="showAllClassesAchievements"
              style="
                display: flex;
                justify-content: center;
                width: min-content;
                margin: 0 auto;
              "
            >
              <table class="reciept-table" style="cursor: default">
                <tr style="cursor: default">
                  <th>№</th>
                  <th style="min-width: 120px">Класс</th>
                  <th style="cursor: default">Всего баллов</th>
                  <th style="cursor: default">Достижений</th>
                  <th style="cursor: default">Средний балл на ученика</th>
                  <th style="cursor: default">Посмотреть достижения</th>
                </tr>
                <tr
                  v-for="(el, index) in allClassesAchievementsList"
                  :key="index"
                  style="background-color: white; cursor: default"
                >
                  <td style="cursor: default">{{ index + 1 }}</td>
                  <td style="cursor: default">
                    <div>{{ el.className }}</div>
                  </td>
                  <td style="cursor: default">
                    <b>{{ el.totalPoints }}</b>
                  </td>
                  <td style="cursor: default">{{ el.countAchievements }}</td>
                  <td style="cursor: default">{{ el.avgPoints }}</td>
                  <td
                    style="color: blue; cursor: pointer; padding: 0"
                    @click="openAchievementsForClass(el)"
                  >
                    Посмотреть
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </details>

        <div style="width: 100%"></div>

        <!-- Статистика по классу -->
        <details
          v-if="selectedClass.classID != 'achievements'"
          style="text-align: auto; width: auto"
          open
        >
          <summary>Рейтинг учеников класса</summary>
          <div style="margin: 5px; width: 90%">
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                padding: 10px;
              "
            >
              <div style="width: 200px">
                <b>Класс</b>
                <select
                  class="form-select"
                  v-model="classInShowAchievementsByClass"
                  style="width: 190px"
                  :disabled="selectedClass.classID !== 'admin'"
                >
                  <option
                    v-for="(user, index) in classList"
                    :key="index"
                    v-bind:value="user"
                  >
                    {{ user.className }}
                  </option>
                </select>
              </div>
              <div style="padding-left: 40px; margin-top: 22px">
                <button
                  @click="countAchievementsByClass()"
                  class="btn btn-primary"
                  :disabled="classInShowAchievementsByClass == null"
                >
                  Загрузить
                </button>
              </div>
            </div>

            <div
              style="display: flex; justify-content: center; width: min-content"
            >
              <table class="reciept-table" style="cursor: default">
                <tr style="cursor: default">
                  <th style="cursor: default">#</th>
                  <th style="min-width: 200px; cursor: default">Фамилия Имя</th>
                  <th style="cursor: default">Всего баллов</th>
                  <th style="cursor: default">Достижений</th>
                  <th style="cursor: default">Конкурсы</th>
                  <th style="cursor: default">Помощь школе</th>
                  <th style="cursor: default">Дисциплина</th>
                  <th style="cursor: default">Учёба</th>
                  <th style="cursor: default">Спорт</th>
                  <th style="cursor: default">Творчество</th>
                  <th style="cursor: default">Посмотреть все</th>
                  <th style="cursor: default">Доска почёта</th>
                </tr>
                <tr
                  v-for="(el, index) in studentListInShowAchievementsByClass"
                  :key="index"
                  style="background-color: white; cursor: default"
                >
                  <td style="cursor: default">{{ index + 1 }}</td>
                  <td style="cursor: default">
                    <div>{{ el.FirstName }} {{ el.LastName }}</div>
                  </td>
                  <td style="cursor: default">
                    <b>{{ el.totalPoints }}</b>
                  </td>
                  <td style="cursor: default">{{ el.countAchievements }}</td>
                  <td style="cursor: default">{{ el.countContests }}</td>
                  <td style="cursor: default">{{ el.countHelp }}</td>
                  <td style="cursor: default">{{ el.countDiscipline }}</td>
                  <td style="cursor: default">{{ el.countStudy }}</td>
                  <td style="cursor: default">{{ el.countSport }}</td>
                  <td style="cursor: default">{{ el.countCreative }}</td>
                  <td
                    style="color: blue; cursor: pointer; padding: 0"
                    @click="openAchievementsByStudent(el)"
                  >
                    Посмотреть
                  </td>
                  <td style="cursor: default">
                    <div v-if="el.HonorBoard">
                      <div v-if="el.HonorBoard.status">
                        ⭐
                        {{ new Date(el.HonorBoard.date).toLocaleDateString() }}
                      </div>
                      <div v-else>
                        <button
                          @click="sendStudentToHonorBoard(el)"
                          class="btn btn-success"
                          v-if="el.totalPoints >= 30"
                        >
                          На доску почёта
                        </button>
                      </div>
                    </div>
                    <button
                      @click="sendStudentToHonorBoard(el)"
                      class="btn btn-success"
                      v-if="el.totalPoints >= 30 && !el.HonorBoard"
                    >
                      На доску почёта
                    </button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </details>

        <div style="width: 100%"></div>

        <!-- карточка достижения -->
        <v-dialog v-model="showAchievementsCart" width="700px">
          <div>
            <div
              style="
                padding: 20px;
                display: flex;
                flex-direction: column;
                border-radius: 5px;
                background-color: aliceblue;
                border: 3px solid #4caf50;
                -webkit-box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
                -moz-box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
                box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
              "
            >
              <div
                style="
                  background-color: white;
                  border-radius: 5px;
                  padding: 5px;
                "
              >
                <div style="font-size: 16px">
                  <b>Карточка достижения №{{ showAchievements._id }}</b>
                </div>
                <div>
                  <b>Дата:</b>&nbsp;{{
                    new Date(showAchievements.date).toLocaleDateString()
                  }}
                </div>
                <div>
                  <b>Ответственный за информацию:</b>&nbsp;{{
                    showAchievements.responsible
                  }}
                </div>
                <div>
                  <b>Участники:</b>&nbsp;
                  <div
                    v-for="(el, index) in showAchievements.studentID"
                    :key="index"
                    class="stud-list-in-viol"
                    style="
                      display: flex;
                      flex-wrap: nowrap;
                      justify-content: space-between;
                    "
                  >
                    <div>
                      {{ showAchievements.classID[index].className }}
                      {{ el.FirstName }}
                      {{ el.LastName }}
                    </div>

                    <div
                      v-if="selectedClass.classID === 'admin'"
                      style="cursor: pointer"
                      @click="
                        deleteStudentInAchievements(el, showAchievements, index)
                      "
                    >
                      ✖
                    </div>
                  </div>
                </div>

                <div><b>Категория:</b>&nbsp;{{ showAchievements.group }}</div>
                <div><b>Уровень:</b>&nbsp;{{ showAchievements.level }}</div>
                <div>
                  <b>Баллы:</b>&nbsp;
                  <span style="font-size: 20px; color: #2e7d32">
                    <b>+{{ showAchievements.points }}</b>
                  </span>
                </div>

                <div>
                  <b>Описание:</b>&nbsp; <br />
                  <div
                    style="
                      background-color: #e8f5e9;
                      border-radius: 5px;
                      padding: 5px;
                      margin: 5px;
                    "
                  >
                    {{ showAchievements.description }}
                  </div>
                </div>
              </div>
              <div>
                <hr />
                <div>
                  <b>Изменение баллов:</b>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="showAchievements.points"
                    v-if="selectedClass.classID === 'admin'"
                  />
                </div>
              </div>
              <div style="top: 10px">
                <b>Комментарий:</b>
                <textarea
                  name=""
                  v-model="showAchievements.comment"
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="5"
                ></textarea>
              </div>

              <v-card-actions id="updateAch">
                <button
                  @click="updateAchievements(showAchievements)"
                  class="btn btn-success"
                  style="width: 100%"
                >
                  Обновить
                </button>
              </v-card-actions>
              <v-card-actions id="del" style="margin: 1px; padding: 1px">
                <div
                  style="width: 100%; display: flex; justify-content: flex-end"
                >
                  <button
                    class="btn btn-danger"
                    @click="showAchievementsCart = !showAchievementsCart"
                    style="right: 0px"
                  >
                    Закрыть
                  </button>
                </div>
              </v-card-actions>
            </div>
          </div>
        </v-dialog>

        <!-- Реестр достижений -->
        <div v-if="selectedClass.classID != 'achievements'" style="margin: 5px">
          <div
            style="
              padding: 20px;
              display: flex;
              flex-direction: column;
              border-radius: 5px;
              -webkit-box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
              -moz-box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
              box-shadow: 4px 4px 8px 0px rgba(0, 72, 172, 0.25);
            "
          >
            <b>Реестр достижений</b> (поиск по таблице "Ctrl+F")
            <div style="width: 200px">
              <button
                style="margin-left: 7px"
                class="btn btn-dark"
                @click="exportData()"
              >
                ЭКСПОРТ ДАННЫХ
              </button>
            </div>

            <v-text-field
              class="search-table"
              v-model="search_result"
              append-icon="mdi-magnify"
              label="Поиск"
            >
            </v-text-field>
            <v-data-table
              :headers="headers"
              :items="achievementsListWithIndex"
              density="compact"
              @click:row="onClickRow"
              class="table-achievements"
              :search="search_result"
            >
              <template v-slot:[`item.index`]="{ item }">
                {{ item.globalIndex }}
              </template>
              <template v-slot:[`item.classID`]="{ item }">
                <div v-if="item.studentID.length == 1">
                  <ul style="padding: 0px; margin: 0px">
                    <li v-for="(el, index) in item.classID" :key="index">
                      {{ el.className }}
                    </li>
                  </ul>
                </div>
                <div v-else>Несколько</div>
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <div style="width: 200px">
                  {{ item.description }}
                </div>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                {{ new Date(item.date).toLocaleDateString() }}
              </template>
              <template v-slot:[`item.studentID`]="{ item }">
                <div v-if="item.studentID.length == 1">
                  <ul style="padding: 0px; margin: 0px">
                    <li v-for="(el, index) in item.studentID" :key="index">
                      {{ el.FirstName }} {{ el.LastName }}
                    </li>
                  </ul>
                </div>
                <div v-else>Несколько</div>
              </template>
              <template v-slot:[`item.points`]="{ item }">
                <div
                  style="
                    background-color: #c8e6c9;
                    padding: 5px;
                    border-radius: 3px;
                    text-align: center;
                    font-weight: bold;
                    color: #2e7d32;
                  "
                >
                  +{{ item.points }}
                </div>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-card-actions id="del" style="margin: 1px; padding: 1px">
                  <div>
                    <button
                      class="btn btn-danger"
                      @click="deleteAchievements(item._id)"
                      v-if="selectedClass.classID === 'admin'"
                    >
                      Удалить
                    </button>
                  </div>
                </v-card-actions>
              </template>
            </v-data-table>
          </div>
        </div>

        <!-- Просмотр достижений ученика -->
        <v-dialog
          v-model="showAchievementsByStudentsCheck"
          style="cursor: default; width: auto; background-color: aliceblue"
        >
          <div
            style="
              cursor: default;
              width: auto;
              background-color: aliceblue;
              height: 100%;
              padding: 20px;
            "
          >
            <div
              style="width: 100%; display: flex; flex-direction: row-reverse"
            >
              <button
                class="btn btn-danger"
                @click="
                  showAchievementsByStudentsCheck =
                    !showAchievementsByStudentsCheck
                "
              >
                Закрыть
              </button>
            </div>
            <div style="margin: 20px">
              <h3>
                Достижения ученика
                <span v-if="showAchievementsByStudents_student">
                  {{ showAchievementsByStudents_student.FirstName }}
                  {{ showAchievementsByStudents_student.LastName }}</span
                >
              </h3>
              Нажмите на "Баллы" для подробностей
            </div>
            <div style="margin: 20px; background-color: white; cursor: default">
              <table class="reciept-table" style="cursor: default">
                <tr>
                  <th style="cursor: default">#</th>
                  <th style="cursor: default">Дата</th>
                  <th style="cursor: default">Категория</th>
                  <th style="cursor: default">Описание</th>
                  <th style="cursor: default">Баллы</th>
                  <th style="cursor: default">Информатор</th>
                  <th style="cursor: default">Комментарий</th>
                </tr>
                <tr
                  v-for="(el, index) in showAchievementsByStudents"
                  :key="index"
                >
                  <td style="cursor: default">{{ index + 1 }}</td>
                  <td style="cursor: default">
                    {{ new Date(el.date).toLocaleDateString() }}
                  </td>
                  <td style="cursor: default">{{ el.group }}</td>
                  <td style="cursor: default">{{ el.description }}</td>
                  <td
                    style="
                      background-color: #c8e6c9;
                      font-weight: bold;
                      color: #2e7d32;
                      text-align: center;
                      cursor: pointer;
                    "
                    @click="onClickRow(el)"
                  >
                    +{{ el.points }}
                  </td>
                  <td style="cursor: default">{{ el.responsible }}</td>
                  <td style="cursor: default">{{ el.comment }}</td>
                </tr>
              </table>
            </div>
          </div>
        </v-dialog>

        <!-- Просмотр достижений по классу -->
        <v-dialog v-model="showAchievementsByClassDialog">
          <div
            style="
              cursor: default;
              width: auto;
              background-color: aliceblue;
              height: 100%;
              padding: 20px;
              max-height: 90vh;
              overflow-y: auto;
            "
          >
            <div
              style="
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <h3 style="margin: 0">
                Достижения класса:
                <span v-if="selectedClassForDialog">
                  {{ selectedClassForDialog.className }}
                </span>
              </h3>
              <button
                class="btn btn-danger"
                @click="showAchievementsByClassDialog = false"
              >
                Закрыть
              </button>
            </div>
            <div style="margin: 20px">Нажмите на "Баллы" для подробностей</div>
            <div style="margin: 20px; background-color: white; cursor: default">
              <table class="reciept-table" style="cursor: default; width: 100%">
                <tr>
                  <th style="cursor: default">#</th>
                  <th style="cursor: default">Дата</th>
                  <th style="cursor: default">Ученик(и)</th>
                  <th style="cursor: default">Категория</th>
                  <th style="cursor: default; min-width: 200px">Описание</th>
                  <th style="cursor: default">Баллы</th>
                  <th style="cursor: default">Информатор</th>
                </tr>
                <tr v-for="(el, index) in achievementsByClassList" :key="index">
                  <td style="cursor: default">{{ index + 1 }}</td>
                  <td style="cursor: default">
                    {{ new Date(el.date).toLocaleDateString() }}
                  </td>
                  <td style="cursor: default">
                    <div v-if="el.studentID.length === 1">
                      {{ el.studentID[0].FirstName }}
                      {{ el.studentID[0].LastName }}
                    </div>
                    <div
                      v-else
                      style="
                        max-width: 200px;
                        max-height: 100px;
                        overflow-y: auto;
                      "
                    >
                      <div
                        v-for="(student, idx) in el.studentID"
                        :key="idx"
                        style="font-size: 0.9rem"
                      >
                        {{ student.FirstName }} {{ student.LastName }}
                      </div>
                    </div>
                  </td>
                  <td style="cursor: default">{{ el.group }}</td>
                  <td style="cursor: default">{{ el.description }}</td>
                  <td
                    style="
                      background-color: #c8e6c9;
                      font-weight: bold;
                      color: #2e7d32;
                      text-align: center;
                      cursor: pointer;
                    "
                    @click="onClickRow(el)"
                  >
                    +{{ el.points }}
                  </td>
                  <td style="cursor: default">{{ el.responsible }}</td>
                </tr>
              </table>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import TutorialDataService from "../services/TutorialDataService";
import * as XLSX from "xlsx";

export default {
  props: {
    selectedClass: Object,
  },
  data() {
    return {
      headers: [
        { value: "index", text: "№", width: "10px" },
        { text: "Класс", sortable: false, value: "classID" },
        { text: "ФИ", value: "studentID" },
        { text: "Дата", value: "date" },
        { text: "Категория", value: "group" },
        { text: "Баллы", value: "points" },
        { text: "Ответственный", value: "responsible", width: "10%" },
        { text: "Действия", value: "actions" },
      ],
      classList: [],
      showAchievementsByStudents: [],
      showAchievementsByStudents_student: null,
      showAchievementsByStudentsCheck: false,
      classInShowAchievementsByClass: null,
      studentListInShowAchievementsByClass: "",
      studentsList: [[]],
      search_result: "",
      showAchievementsCart: false,

      achievementsList: [],
      showAchievements: {
        date: new Date().toISOString().slice(0, 10),
      },

      newAchievements: {
        studentID: [""],
        classID: [""],
        responsible: "",
        description: "",
        group: "Конкурсы и мероприятия",
        level: "Школьный",
        date: new Date().toISOString().slice(0, 10),
        points: 5,
        isCustomPoints: false,
        comment: "",
      },

      // Справочник рекомендованных баллов по категории и уровню
      recommendedPointsMap: {
        "Конкурсы и мероприятия": {
          Школьный: 5,
          Районный: 10,
          Городской: 15,
          Краевой: 25,
          Всероссийский: 40,
          Международный: 50,
        },
        "Помощь школе": {
          Школьный: 3,
          Районный: 5,
          Городской: 8,
          Краевой: 10,
          Всероссийский: 15,
          Международный: 20,
        },
        "Хорошая дисциплина": {
          Школьный: 5,
          Районный: 5,
          Городской: 5,
          Краевой: 5,
          Всероссийский: 5,
          Международный: 5,
        },
        "Учебные успехи": {
          Школьный: 5,
          Районный: 10,
          Городской: 15,
          Краевой: 25,
          Всероссийский: 40,
          Международный: 50,
        },
        "Спортивные достижения": {
          Школьный: 5,
          Районный: 10,
          Городской: 15,
          Краевой: 25,
          Всероссийский: 40,
          Международный: 50,
        },
        "Творческие успехи": {
          Школьный: 5,
          Районный: 10,
          Городской: 15,
          Краевой: 25,
          Всероссийский: 40,
          Международный: 50,
        },
        "Общественная деятельность": {
          Школьный: 5,
          Районный: 8,
          Городской: 12,
          Краевой: 20,
          Всероссийский: 30,
          Международный: 40,
        },
        Прочее: {
          Школьный: 3,
          Районный: 5,
          Городской: 8,
          Краевой: 10,
          Всероссийский: 15,
          Международный: 20,
        },
      },

      allClassesAchievementsList: [],
      showAllClassesAchievements: false,
      showAchievementsByClassDialog: false,
      selectedClassForDialog: null,
      achievementsByClassList: [],
    };
  },
  computed: {
    recommendedPoints() {
      const g = this.newAchievements.group;
      const l = this.newAchievements.level;
      if (this.recommendedPointsMap[g] && this.recommendedPointsMap[g][l]) {
        return this.recommendedPointsMap[g][l];
      }
      return 5;
    },
    achievementsListWithIndex() {
      return this.achievementsList
        .slice()
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .map((item, index) => ({
          ...item,
          globalIndex: index + 1,
        }));
    },
  },
  methods: {
    // ---------- БАЛЛЫ ----------
    onCategoryChange() {
      // при смене категории/уровня подставляем рекомендованные баллы,
      // если пользователь ещё не менял их вручную
      if (!this.newAchievements.isCustomPoints) {
        this.newAchievements.points = this.recommendedPoints;
      }
    },
    setPoints(p) {
      this.newAchievements.points = p;
      this.checkCustom();
    },
    incPoints() {
      this.newAchievements.points = (this.newAchievements.points || 0) + 1;
      this.checkCustom();
    },
    decPoints() {
      this.newAchievements.points = Math.max(
        0,
        (this.newAchievements.points || 0) - 1,
      );
      this.checkCustom();
    },
    resetPoints() {
      this.newAchievements.points = this.recommendedPoints;
      this.newAchievements.isCustomPoints = false;
    },
    checkCustom() {
      this.newAchievements.isCustomPoints =
        this.newAchievements.points !== this.recommendedPoints;
    },

    // ---------- СТАТИСТИКА ПО КЛАССАМ ----------
    async countAchievementsForAllClasses() {
      this.allClassesAchievementsList = [];
      this.showAllClassesAchievements = true;

      for (const classItem of this.classList) {
        let cls = {
          classID: classItem.classID,
          className: classItem.className,
          totalPoints: 0,
          countAchievements: 0,
          avgPoints: 0,
        };

        let studentsCount = 0;

        for (const ach of this.achievementsList) {
          const hasStudentsFromClass = ach.studentID.some((student, index) => {
            return (
              ach.classID[index] &&
              ach.classID[index].classID === classItem.classID
            );
          });
          if (hasStudentsFromClass) {
            cls.totalPoints += ach.points || 0;
            cls.countAchievements++;
          }
        }

        // средний балл на ученика
        try {
          const r = await TutorialDataService.findStudentByClassID({
            classID: classItem.classID,
            className: classItem.className,
          });
          studentsCount = Object.keys(r.data).length;
        } catch (e) {
          studentsCount = 0;
        }
        cls.avgPoints = studentsCount
          ? Math.round(cls.totalPoints / studentsCount)
          : 0;

        this.allClassesAchievementsList.push(cls);
      }

      this.allClassesAchievementsList.sort(
        (a, b) => b.totalPoints - a.totalPoints,
      );
      this.$forceUpdate();
    },

    openAchievementsForClass(classItem) {
      this.selectedClassForDialog = classItem;
      this.achievementsByClassList = [];

      for (const ach of this.achievementsList) {
        const hasStudentsFromClass = ach.studentID.some((student, index) => {
          return (
            ach.classID[index] &&
            ach.classID[index].classID === classItem.classID
          );
        });
        if (hasStudentsFromClass) this.achievementsByClassList.push(ach);
      }

      this.achievementsByClassList.sort(
        (a, b) => new Date(b.date) - new Date(a.date),
      );
      this.showAchievementsByClassDialog = true;
    },

    // ---------- ДОСКА ПОЧЁТА ----------
    async sendStudentToHonorBoard(el) {
      if (
        confirm(
          "Добавить ученика на Доску почёта? Это публичный список лучших учеников.",
        )
      ) {
        await TutorialDataService.sendStudentToHonorBoard(el._id, {
          status: true,
        })
          .then(() => this.countAchievementsByClass())
          .catch((e) => {
            console.log(e);
            alert("Ошибка");
          });
      }
    },

    // ---------- КАРТОЧКА ----------
    deleteStudentInAchievements(student, showAchievements, index) {
      if (this.showAchievements.studentID.length > 1) {
        this.showAchievements.classID.splice(index, 1);
        this.showAchievements.studentID.splice(index, 1);
      } else {
        alert(
          "Должен быть хотя бы один ученик. Если хотите удалить всех - удалите достижение полностью",
        );
      }
    },

    openAchievementsByStudent(arrID) {
      this.showAchievementsByStudentsCheck =
        !this.showAchievementsByStudentsCheck;
      this.showAchievementsByStudents_student = arrID;
      this.showAchievementsByStudents = [];
      for (let i = 0; i < this.achievementsList.length; i++)
        arrID.achievementsID.forEach((el) => {
          if (this.achievementsList[i]._id == el) {
            this.showAchievementsByStudents.push(this.achievementsList[i]);
          }
        });
      this.$forceUpdate();
    },

    async countAchievementsByClass() {
      let data = {
        classID: this.classInShowAchievementsByClass.classID,
        className: this.classInShowAchievementsByClass.className,
      };
      await TutorialDataService.findStudentByClassID(data)
        .then((response) => {
          this.studentListInShowAchievementsByClass = Object.values(
            response.data,
          );
        })
        .catch((e) => console.log(e));

      let tempIDstud = [];
      this.achievementsList.forEach((el) => {
        el.studentID.forEach((stud) => {
          tempIDstud.push({
            studentID: stud._id,
            achievementsID: el._id,
            points: el.points || 0,
            group: el.group,
          });
        });
      });

      this.studentListInShowAchievementsByClass.forEach((el) => {
        el.totalPoints = 0;
        el.countAchievements = 0;
        el.countContests = 0;
        el.countHelp = 0;
        el.countDiscipline = 0;
        el.countStudy = 0;
        el.countSport = 0;
        el.countCreative = 0;
        el.achievementsID = [];
        tempIDstud.forEach((id) => {
          if (id.studentID == el._id) {
            el.totalPoints += id.points;
            el.countAchievements++;
            el.achievementsID.push(id.achievementsID);

            if (id.group == "Конкурсы и мероприятия") el.countContests++;
            if (id.group == "Помощь школе") el.countHelp++;
            if (id.group == "Хорошая дисциплина") el.countDiscipline++;
            if (id.group == "Учебные успехи") el.countStudy++;
            if (id.group == "Спортивные достижения") el.countSport++;
            if (id.group == "Творческие успехи") el.countCreative++;
          }
        });
      });

      // сортируем по баллам убыв.
      this.studentListInShowAchievementsByClass.sort(
        (a, b) => b.totalPoints - a.totalPoints,
      );

      this.$forceUpdate();
    },

    // ---------- ОБЩЕЕ ----------
    onClickRow(item) {
      this.showAchievementsCart = !this.showAchievementsCart;
      this.showAchievements = item;
    },

    async deleteAchievements(id) {
      let check = prompt(
        "Вы действительно хотите удалить достижение? Введите ID достижения для подтверждения:",
        ["ID достижения"],
      );
      if (check == id) {
        await TutorialDataService.deleteAchievements(id)
          .then(() => {
            this.getAllAchievements();
            this.showAchievementsCart = !this.showAchievementsCart;
          })
          .catch((e) => console.log(e));
      }
    },

    addStudentNewAchiev() {
      this.newAchievements.classID.push("");
      this.newAchievements.studentID.push("");
    },

    async updateAchievements(item) {
      let data = {
        classID: this.showAchievements.classID,
        studentID: this.showAchievements.studentID,
        points: this.showAchievements.points,
        comment: this.showAchievements.comment,
      };
      await TutorialDataService.updateAchievements(item._id, data)
        .then(() => {
          alert("Успешно обновлено!");
        })
        .catch((e) => {
          console.log(e);
          alert("Произошла ошибка");
        });
    },

    createAchievements() {
      if (
        this.newAchievements.responsible.length > 3 &&
        this.newAchievements.classID[0].className &&
        this.newAchievements.group.length > 3 &&
        this.newAchievements.description.length > 3 &&
        this.newAchievements.points > 0
      ) {
        let data = this.newAchievements;

        TutorialDataService.createAchievements(data)
          .then(() => {
            alert(`Начислено ${data.points} баллов!`);
            this.getAllAchievements();

            // сброс формы
            this.newAchievements = {
              studentID: [""],
              classID: [""],
              responsible: "",
              description: "",
              group: "Конкурсы и мероприятия",
              level: "Школьный",
              date: new Date().toISOString().slice(0, 10),
              points: 5,
              isCustomPoints: false,
              comment: "",
            };
            this.studentsList = [[]];
          })
          .catch((e) => console.log(e));
      } else {
        alert("Заполните поля! Баллы должны быть больше 0.");
      }
    },

    getDisplayClass(data) {
      return {
        classID: data._id,
        className: data.className,
      };
    },
    getDisplayStudent(data) {
      return {
        _id: data._id,
        FirstName: data.FirstName,
        LastName: data.LastName,
        classID: data.classID,
      };
    },

    async getAllClass() {
      await TutorialDataService.getAllCLass()
        .then((response) => {
          this.classList = response.data.map(this.getDisplayClass);
        })
        .catch((e) => console.log(e));
    },

    async getAllAchievements() {
      await TutorialDataService.getAllAchievements()
        .then((response) => {
          this.achievementsList = response.data;
        })
        .catch((e) => console.log(e));
    },

    async getStudentsList(index) {
      await TutorialDataService.findStudentByClassIDbyDashboard(
        this.newAchievements.classID[index],
      ).then((response) => {
        let temp = [];
        for (let key in response.data) {
          temp.push(response.data[key]);
        }
        this.$set(this.studentsList, index, temp.map(this.getDisplayStudent));
      });
    },

    exportData() {
      let data = [
        [
          "№",
          "Дата",
          "Класс",
          "Ученик(и)",
          "Категория",
          "Уровень",
          "Баллы",
          "Описание",
          "Ответственный",
          "Комментарий",
        ],
      ];

      for (let i = 0; i < this.achievementsList.length; i++) {
        let str = [];
        str.push(i + 1);
        str.push(new Date(this.achievementsList[i].date).toLocaleDateString());
        str.push(
          this.achievementsList[i].classID
            .map((item) => item.className)
            .join(", "),
        );
        str.push(
          this.achievementsList[i].studentID
            .map((item) => item.FirstName + " " + item.LastName)
            .join(", "),
        );
        str.push(this.achievementsList[i].group);
        str.push(this.achievementsList[i].level);
        str.push(this.achievementsList[i].points);
        str.push(this.achievementsList[i].description);
        str.push(this.achievementsList[i].responsible);
        str.push(this.achievementsList[i].comment);
        data.push(str);
      }
      this.exportXLSX(data);
    },

    exportXLSX(ws_data) {
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.SheetNames.push("Achievements");
      wb.Sheets["Achievements"] = ws;
      var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
      function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
      this.downloadBlob(
        new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
        "Достижения.xlsx",
      );
    },

    downloadBlob(content, filename, contentType) {
      var blob = new Blob([content], { type: contentType });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
  },

  async mounted() {
    await this.getAllClass();
    await this.getAllAchievements();

    if (
      this.selectedClass &&
      this.selectedClass.classID !== "admin" &&
      this.selectedClass.classID !== "achievements"
    ) {
      this.classInShowAchievementsByClass = this.selectedClass;
      await this.countAchievementsByClass();
    }
  },
};
</script>

<style scoped>
.table-achievements,
td,
th {
  cursor: pointer;
}

details {
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 10px 0;
  padding: 10px;
  cursor: pointer;
  background-color: #f9f9f9;
  transition: background-color 0.3s;
}

details[open] {
  background-color: #e8f5e9;
  cursor: default;
}

summary {
  font-weight: bold;
}

summary::-webkit-details-marker {
  display: none;
}

.table-achievements :deep(.v-data-table__tr) {
  height: 36px;
}

.table-achievements :deep(.v-data-table__td) {
  padding: 4px 8px;
  font-size: 0.875rem;
}

.table-achievements :deep(.v-data-table-header__content) {
  font-size: 0.875rem;
  font-weight: 600;
}

.stud-list-in-viol:hover {
  background-color: #e8f5e9;
}
</style>
